<!-- ╔══════════════════════════╗
     ║     SECTION 4 : VIDEO    ║
     ╚══════════════════════════╝ -->
<template>
  <section
    id="video"
    class="py-16 white--text"
    style="background-color: #004c91"
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <div class="video-wrapper elevation-10 rounded-lg">
            <iframe
              src="https://www.youtube.com/embed/YtTEMWO6kVc"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
          <div class="mt-10 text-center">
            <p
              :class="[
                $vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6',
                'font-weight-light',
              ]"
            >
              {{ $t("section_4_video_text") }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->
<script>
import Vue from "vue";

export default Vue.extend({
  name: "video-section",
});
</script>

<!-- ╔═══════════════╗
     ║     STYLE     ║
     ╚═══════════════╝ -->
<style scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* Ratio 16:9 */
  height: 0;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
